import PropTypes from "prop-types";
import { BRANDS, QUOTATION_ITEMS_TYPE } from "app/constants";
import QuotationItem from "app/pages/Booking/Quotation/PriceDetails/QuotationItems/QuotationItem";
import { brandPropTypes, quotationItemShape } from "app/utils/propTypes";
import { memo } from "react";

const QuotationItems = ({
	quotationItems = [],
	brand,
	flexExtra = 0,
	deltaBasePrice = 0,
	isPaymentPage,
}) => {
	return (
		<>
			{quotationItems.map((quotationItem, index) => {
				const isBasePrice = index === 0;
				const basePrice = isPaymentPage
					? quotationItem.price + flexExtra + deltaBasePrice
					: quotationItem.price + flexExtra;
				const hideQuotationItem =
					quotationItem.type === QUOTATION_ITEMS_TYPE.BOOKING_FEES && brand === BRANDS.AX;
				return (
					!hideQuotationItem && (
						<QuotationItem
							key={quotationItem.description}
							description={quotationItem.description}
							price={isBasePrice ? basePrice : quotationItem.price}
							/* Version prix par personne
							unitPrice={quotationItem.unitPrice}
							quantity={quotationItem.quantity}
							*/
							isBasePrice={isBasePrice}
						/>
					)
				);
			})}
		</>
	);
};

QuotationItems.propTypes = {
	quotationItems: PropTypes.arrayOf(quotationItemShape),
	flexExtra: PropTypes.number,
	brand: brandPropTypes,
	deltaBasePrice: PropTypes.number,
	isPaymentPage: PropTypes.bool,
};

export default memo(QuotationItems);
